import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import { Grid, Stack, Typography } from "@mui/material";
import { convertISODateTime } from "@entrilia/shared/utilities/dateUtils";
import KeyValueColumn from "../../common/KeyValueColumn";

interface Props {
  lastChangedBy?: string;
  lastChangedOn?: string;
  lastBackupDate?: string;
  isLatestBackupSuccessful?: boolean;
}

const DataBackupSetup = ({ lastBackupDate, lastChangedBy, lastChangedOn, isLatestBackupSuccessful }: Props) => {
  return (
    <Stack spacing={1}>
      <Typography variant="subtitle1">Setup</Typography>
      <Grid container spacing={5}>
        <Grid>
          <KeyValueColumn title="Modified by" value={lastChangedBy || "-"} />
        </Grid>
        <Grid>
          <KeyValueColumn title="Modified at" value={lastChangedOn ? convertISODateTime(lastChangedOn) : "-"} />
        </Grid>
        <Grid>
          <KeyValueColumn
            title="Last Backup"
            value={lastBackupDate ? convertISODateTime(lastBackupDate) : "-"}
            icon={
              lastBackupDate ? (
                isLatestBackupSuccessful === true ? (
                  <CheckRoundedIcon color="primary" />
                ) : (
                  <CancelRoundedIcon color="error" />
                )
              ) : null
            }
          />
        </Grid>
      </Grid>
    </Stack>
  );
};

export default DataBackupSetup;
